import assets from './asset.manifest.js';
import Balance from './services/Balance.js';

export default {
    data() {
        return {
            tested: [],
            loaded_asset: [],
            error_asset: [],
            complete: null,
            delay: 1000,
        }
    },

    methods: {
        async preloadStart(complete) {
            this.complete = complete;
            await Promise.all([
                Balance.getSLCodes().then((response) => {
                    this.$store.state.ledgers.types = response.data.data;
                }),
                this.start()
            ]);

            this.finish();
        },

        async getSLCodes() {
            try {
                const response = await Balance.getSLCodes();
                this.sl_codes = response || [];
            } catch (error) {
                console.error('Failed to load SL Codes', error);
            }
        },

        start() {
            return new Promise((resolve) => {

                if (assets.length === 0) {
                    resolve();
                    return;
                }

                assets.forEach((asset) => {
                    this.tested.push(asset);

                    let image = new Image();

                    image.src =
                        process.env.VUE_APP_MEDIA_URL +
                        'images' +
                        asset;

                    image.onload = () => {
                        this.loaded_asset.push(asset);
                        this.checkAssets(resolve);
                    };

                    image.onerror = () => {
                        this.error_asset.push(asset);
                        this.checkAssets(resolve);
                    };
                });
            });
        },

        checkAssets(resolve) {
            if (
                this.loaded_asset.length +
                this.error_asset.length ===
                assets.length
            ) {
                resolve();
            }
        },

        finish() {
            let t = setTimeout(() => {
                this.complete && this.complete();
                clearTimeout(t);
            }, this.delay);
        }
    }
}